import getCanPlayAds from "selectors/ads/getCanPlayAds";
import getIsMobileSafari from "selectors/device/getIsMobileSafari";
import getIsTablet from "selectors/device/getIsTablet";
import { createSelector } from "reselect";

const getCanPlaySkippableAds = createSelector(
  [getCanPlayAds, getIsMobileSafari, getIsTablet],
  (canPlayAds, isMobileSafari, isTablet) => {
    if (!canPlayAds) {
      return false;
    }
    if (isTablet) {
      return true;
    }

    return !isMobileSafari;
  },
);

export default getCanPlaySkippableAds;
